import instance from "./axios";


//登录
export const loginApi = (params) => {
  return instance.get('/api/login', { params });
};

//订单列表
export const orderListApi = (params) => {
  return instance.get('/api/order_pay', { params });
};

//游戏列表
export const gameListApi = (params) => {
  return instance.get('/api/game', { params });
};

//用户信息
export const userApi = (params) => {
  return instance.get('/api/user_pay', { params });
};

//用户列表
export const userListApi = (params) => {
  return instance.get('/api/user_pay_list', { params });
};